import React from "react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="App-footer">
            <div className="footer-content">
                <p>
                    &copy; {currentYear} TextCounter. Natsu16 All rights
                    reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
